import * as React from 'react';
import b_ from 'b_';
import { useHistory } from 'react-router';
import { useTranslation } from 'react-i18next';
import { StockTopCardHeaderFragment } from './__generated__/StockTopCardHeaderFragment';
import StockIcon from 'components/StockIcon';
import RiskInfo from 'components/RiskInfo';

import './index.scss';

interface Props {
  stock: StockTopCardHeaderFragment;
}

const b = b_.with('stock-top-card-header');

const StockTopCardHeader: React.FC<Props> = ({ stock }) => {
  const { t } = useTranslation();

  const history = useHistory();

  const { logoUrl, name, title, risk, sector, industry, type } = stock;

  const back = () => {
    if (history.length > 1) {
      return history.goBack();
    }
    history.push('/investments/stocks');
    return null;
  };

  return (
    <div className={b()}>
      <button className={b('button-back')} onClick={back} />
      <div className={b('wrapper')}>
        <div className={b('logo-wrapper')}>
          <StockIcon name={name} url={logoUrl} big />
          <h2 className={b('name')}>{title}</h2>
        </div>
      </div>
      <div className={b('info')}>
        <div className={b('category')}>{t(type)}</div>
        <div className={b('industry')}>{industry}</div>
        <div className={b('sector')}>{sector}</div>
        <div className={b('risk')}>
          <RiskInfo shapedIcons withText>
            {risk}
          </RiskInfo>
        </div>
      </div>
    </div>
  );
};

export default StockTopCardHeader;
